export default "__VITE_ASSET__DaQ5zOj___"